// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-calendar {
  position: relative;
  background-color: #fff;
  color: #222;
}
.srprs-calendar.static-height {
  height: 550px;
}
.srprs-calendar header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-between;
  width: calc(100% - 18px);
  line-height: 15px;
  overflow: hidden;
  margin-left: 9px;
  border-width: 0 0 1px;
  border-style: solid;
  border-color: #e7e7e7;
  text-align: center;
  text-transform: uppercase;
}
.srprs-calendar header > div {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
}
.srprs-calendar header .month-name {
  display: inline-block;
  margin-right: 4px;
}
.srprs-calendar header .srprs-button {
  width: 50px;
  height: 24px;
  padding: 0;
  line-height: 24px;
  border: none;
  background-color: transparent;
}
.srprs-calendar header .srprs-button .srprs-icon:not(.transport-switch) {
  bottom: 0;
  width: 12px;
  height: 12px;
}
.srprs-calendar header .srprs-button .srprs-icon:not(.transport-switch) svg *,
.srprs-calendar header .srprs-button svg * {
  fill: #222;
}
.srprs-calendar .header-extended {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: space-around;
  position: relative;
  border-width: 0;
}
.srprs-calendar .header-extended div {
  vertical-align: middle;
}
.srprs-calendar .header-extended .date-date {
  width: 40px;
}
.srprs-calendar .header-extended .date-date .srprs-icon {
  width: 32px;
  height: 64px;
  font-size: 28px;
}
.srprs-calendar .header-extended .date-date .srprs-icon svg {
  width: 28px;
}
.srprs-calendar .header-extended .date-month {
  width: calc(100% - 160px);
  margin-right: 12px;
  text-align: left;
}
.srprs-calendar .header-extended .date-month .heading {
  display: block;
  font-weight: normal;
  font-size: 12px;
}
.srprs-calendar .header-extended .date-month .month span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  max-width: 4ch;
  top: 2px;
}
.srprs-calendar .header-extended .srprs-buttonGroup {
  width: 100px;
  text-align: right;
}
.srprs-calendar .srprs-loader,
.srprs-calendar .srprs-preloader {
  background-color: #fff;
}

@media screen and (min-width: 375px) {
  .srprs-calendar .header-extended .date-month {
    width: calc(100% - 200px);
  }
  .srprs-calendar .header-extended .srprs-buttonGroup {
    width: auto;
  }
}
@media screen and (min-width: 640px) {
  .srprs-calendar .header-extended .date-date .srprs-icon {
    width: 60px;
    height: 64px;
    border-width: 0 1px 0 0;
    border-style: solid;
    border-color: #e7e7e7;
    font-size: 38px;
  }
  .srprs-calendar .header-extended .date-month {
    width: calc(100% - 300px);
    margin-left: -42px;
  }
  .srprs-calendar .header-extended .date-month strong {
    font-size: 18px;
  }
  .srprs-calendar .header-extended .date-month .heading {
    font-size: 14px;
  }
  .srprs-calendar .header-extended .date-month .month span {
    top: 4px;
    max-width: 24ch;
  }
  .srprs-calendar .srprs-buttongroup {
    width: 102px;
  }
  .srprs-calendar .srprs-buttongroup .srprs-button {
    width: 50px;
    height: 50px;
    padding-top: 0.45em;
  }
}
@media screen and (min-width: 768px) {
  .srprs-calendar header {
    width: calc(100% - 6px);
  }
  .srprs-calendar .header-extended {
    margin-bottom: 10px;
    margin-left: 4px;
    line-height: 18px;
  }
  .srprs-calendar .header-extended .date-date .srprs-icon svg {
    width: 36px;
  }
  .srprs-calendar .header-extended .date-month .month span {
    top: 3px;
  }
  .srprs-calendar .header-extended > .srprs-icon {
    left: 0;
    width: 67px;
  }
  .srprs-calendar .header-extended > .srprs-icon svg {
    width: 38px;
  }
  .srprs-calendar .header-extended > .srprs-icon + .month-name {
    padding-left: 87px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Calendar/Calendar.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_truncate.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,kBAAA;EAEE,sBAAA;EAEF,WAAA;AAqMF;AApME;EACE,aAAA;AAsMJ;AApME;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EAEA,wBAAA;EACA,iBAAA;EACA,gBAAA;EAEE,gBAAA;EAGA,qBAAA;EACA,mBAAA;EACA,qBAAA;EAGA,kBAAA;EACA,yBAAA;AAgMN;AA9LI;EACE,qBAAA;EAEE,iBAAA;EACA,eAAA;AA+LR;AA5LI;EACE,qBAAA;EACA,iBAAA;AA8LN;AA5LI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EAEE,6BAAA;AA6LR;AA3LM;EACE,SAAA;EACA,WAAA;EACA,YAAA;AA6LR;AAzLQ;;EACE,UAAA;AA4LV;AAvLE;EACE,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EAEE,eAAA;AAwLN;AAtLI;EAEI,sBAAA;AAuLR;AApLI;EACE,WAAA;AAsLN;AArLM;EACE,WAAA;EACA,YAAA;EAEE,eAAA;AAsLV;AApLQ;EACE,WAAA;AAsLV;AAlLI;EACE,yBAAA;EAEE,kBAAA;EAGA,gBAAA;AAiLR;AA/KM;EACE,cAAA;EAEE,mBAAA;EACA,eAAA;AAgLV;AA5KQ;EI9GN,gBAAA;EACA,mBAAA;EACA,uBAAA;EJ+GQ,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AA+KV;AA3KI;EACE,YAAA;EAEE,iBAAA;AA4KR;AAxKE;;EAGI,sBAAA;AAyKN;;ACxSI;EDuIE;IACE,yBAAA;EAqKN;EAnKI;IACE,WAAA;EAqKN;AACF;ACjTI;EDqJI;IACE,WAAA;IACA,YAAA;IAEE,uBAAA;IACA,mBAAA;IACA,qBAAA;IAGA,eAAA;EA4JV;EAxJI;IACE,yBAAA;IAEE,kBAAA;EAyJR;EAvJM;IAEI,eAAA;EAwJV;EArJM;IAEI,eAAA;EAsJV;EAlJQ;IACE,QAAA;IACA,eAAA;EAoJV;EA/IE;IACE,YAAA;EAiJJ;EAhJI;IACE,WAAA;IACA,YAAA;IAEE,mBAAA;EAiJR;AACF;ACjVI;EDwMA;IACE,uBAAA;EA4IJ;EA1IE;IAEI,mBAAA;IACA,gBAAA;IAEF,iBAAA;EA0IJ;EAvIQ;IACE,WAAA;EAyIV;EAlIQ;IACE,QAAA;EAoIV;EA/HI;IACE,OAAA;IACA,WAAA;EAiIN;EAhIM;IACE,WAAA;EAkIR;EAhIM;IAEI,kBAAA;EAiIV;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","$cdn-url: 'https://store.cdn.srprs.me/';\n@charset \"UTF-8\";\n@import '../_Assets/scss/core';\n\n.srprs-calendar {\n  position: relative;\n  background: {\n    color: color(white);\n  }\n  color: color(black);\n  &.static-height {\n    height: 550px;\n  }\n  header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    align-content: space-between;\n\n    width: calc(100% - 18px);\n    line-height: 15px;\n    overflow: hidden;\n    margin: {\n      left: 9px;\n    }\n    border: {\n      width: 0 0 1px;\n      style: solid;\n      color: color(grey-light);\n    }\n    text: {\n      align: center;\n      transform: uppercase;\n    }\n    > div {\n      display: inline-block;\n      font: {\n        weight: bold;\n        size: 16px;\n      }\n    }\n    .month-name {\n      display: inline-block;\n      margin-right: 4px;\n    }\n    .srprs-button {\n      width: 50px;\n      height: 24px;\n      padding: 0;\n      line-height: 24px;\n      border: none;\n      background: {\n        color: transparent;\n      }\n      .srprs-icon:not(.transport-switch) {\n        bottom: 0;\n        width: 12px;\n        height: 12px;\n      }\n      .srprs-icon:not(.transport-switch) svg,\n      svg {\n        * {\n          fill: color(black);\n        }\n      }\n    }\n  }\n  .header-extended {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    align-content: space-around;\n    position: relative;\n    border: {\n      width: 0;\n    }\n    div {\n      vertical: {\n        align: middle;\n      }\n    }\n    .date-date {\n      width: 40px;\n      .srprs-icon {\n        width: 32px;\n        height: 64px;\n        font: {\n          size: 28px;\n        }\n        svg {\n          width: 28px;\n        }\n      }\n    }\n    .date-month {\n      width: calc(100% - 160px);\n      margin: {\n        right: 12px;\n      }\n      text: {\n        align: left;\n      }\n      .heading {\n        display: block;\n        font: {\n          weight: normal;\n          size: 12px;\n        }\n      }\n      .month {\n        span {\n          @include truncate();\n\n          display: inline-block;\n          position: relative;\n          max-width: 4ch;\n          top: 2px;\n        }\n      }\n    }\n    .srprs-buttonGroup {\n      width: 100px;\n      text: {\n        align: right;\n      }\n    }\n  }\n  .srprs-loader,\n  .srprs-preloader {\n    background: {\n      color: color(white);\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-calendar {\n    .header-extended {\n      .date-month {\n        width: calc(100% - 200px);\n      }\n      .srprs-buttonGroup {\n        width: auto;\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-landscape) {\n  .srprs-calendar {\n    .header-extended {\n      .date-date {\n        .srprs-icon {\n          width: 60px;\n          height: 64px;\n          border: {\n            width: 0 1px 0 0;\n            style: solid;\n            color: color(grey-light);\n          }\n          font: {\n            size: 38px;\n          }\n        }\n      }\n      .date-month {\n        width: calc(100% - 300px);\n        margin: {\n          left: -42px;\n        }\n        strong {\n          font: {\n            size: 18px;\n          }\n        }\n        .heading {\n          font: {\n            size: 14px;\n          }\n        }\n        .month {\n          span {\n            top: 4px;\n            max-width: 24ch;\n          }\n        }\n      }\n    }\n    .srprs-buttongroup {\n      width: 102px;\n      .srprs-button {\n        width: 50px;\n        height: 50px;\n        padding: {\n          top: 0.45em;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-calendar {\n    header {\n      width: calc(100% - 6px);\n    }\n    .header-extended {\n      margin: {\n        bottom: 10px;\n        left: 4px;\n      }\n      line-height: 18px;\n      .date-date {\n        .srprs-icon {\n          svg {\n            width: 36px;\n          }\n        }\n      }\n\n      .date-month {\n        .month {\n          span {\n            top: 3px;\n          }\n        }\n      }\n\n      > .srprs-icon {\n        left: 0;\n        width: 67px;\n        svg {\n          width: 38px;\n        }\n        & + .month-name {\n          padding: {\n            left: 87px;\n          }\n        }\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin truncate() {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
